import React from 'react'
import { useSelector } from 'react-redux'
import Moment from 'react-moment';

export default function DateTime({ datetime, format }) {
    const timezone = useSelector((state) => state.appGlobal.timezone)

    return (
        <>
            {datetime && <Moment tz={timezone} format={format}>{datetime}</Moment>}
        </>
    );
}


export function DateTimeNoTimezone({ datetime, format }) {

    return (
        <>
            {datetime && <Moment format={format}>{datetime}</Moment>}
        </>
    );
}







